import { IAdherent } from './adherent.model';
import { RoleNavigationMarinEnum } from '../constant/enum';

export interface IProjetAnneeModuleMarinEncadrantNautique {
  id?: number;
  adherent?: IAdherent;
  roleNavigationMarin?: RoleNavigationMarinEnum;
}

export class ProjetAnneeModuleMarinEncadrantNautique implements IProjetAnneeModuleMarinEncadrantNautique {
  constructor(
    public id?: number,
    public adherent?: IAdherent,
    public roleNavigationMarin?: RoleNavigationMarinEnum
  ) { }
}
